// src/components/ResumeHtmlGenerator.js
/**
 * ResumeHtmlGenerator.js
 *
 * Utility to convert structured resume data into HTML format directly
 */
import templates, { getTemplates } from "./ResumeTemplates";

// Default template to use if none specified
const DEFAULT_TEMPLATE = "standard";

/**
 * Main function to generate HTML from resume data
 * @param {Object} resumeData - Structured resume data
 * @param {string} templateName - Name of the template to use (optional)
 * @returns {string} Complete HTML representation of the resume
 */
export const generateResumeHtml = (
  resumeData,
  templateName = DEFAULT_TEMPLATE
) => {
  if (!resumeData) return "";

  // Use the specified template or fall back to default
  const template = templates[templateName] || templates[DEFAULT_TEMPLATE];

  // Generate HTML using the template's generator function
  return template.generator(resumeData);
};

// Re-export the getTemplates function
export { getTemplates };

export default generateResumeHtml;
